export default __webpack_public_path__ + "static/media/car4.3d783604.jpg";